import { useEffect, useState } from 'react'
import { makeRequest } from 'services/request.service'

export const useDashboardFilterOptions = (farmId) => {
  const [options, setOptions] = useState({
    sectors: [],
    groups: []
  })

  useEffect(() => {
    if (!farmId) return

    const headers = { Authorization: `Bearer ${localStorage.getItem('secret')}` }

    Promise.all([
      makeRequest({ method: 'GET', url: `/management/farming-blocks/block-groups/${farmId}`, headers }),
      makeRequest({ method: 'GET', url: `/management/devices/groups/${farmId}`, headers })
    ])
      .then(([sectorsResponse, groupsResponse]) => {
        setOptions({
          sectors: Array.isArray(sectorsResponse.data) ? sectorsResponse.data : [],
          groups: Array.isArray(groupsResponse.data) ? groupsResponse.data : []
        })
      })
      .catch(error => {
        console.error('Failed to load dashboard filter options:', error)
      })
  }, [farmId])

  return options
}
